$(".blogs-main-box-slider").slick({
  centerMode: false,
  centerPadding: "00px",
  slidesToShow: 4,
  arrows: false,
  dots: false,
  infinite:false,
  autoplay: true,
  autoplaySpeed: 2500,
  responsive: [
    {
      breakpoint: 992,
      settings: {
        arrows: false,
        dots: false,
        centerMode: false,
        centerPadding: "0px",
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 749,
      settings: {
        arrows: false,
        dots: false,
        centerMode: false,
        centerPadding: "0px",
        slidesToShow: 1.20,
      },
    }
  ],
});
